import React from 'react'
import styled from 'styled-components'
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";

function ImgSlider() {
    let settings = {
        dots: true,
        infinity: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true
    }
    return (
        <Carousel {...settings}>
             <Wrap>
               <img src="/images/banner1.png" alt=""/>
           </Wrap>

           <Wrap>
               <img src="/images/banner2.png" alt="" />
           </Wrap>

           

        </Carousel>
    )
}

export default ImgSlider

const Carousel = styled(Slider)`
    margin-top: 20px;

    @media only screen and (min-width: 480px) and (max-width: 768px) {
   
        margin-top: 10px;
        
     
      }
    @media only screen and (max-width: 479px) {
        margin-top: 10px;
        
      }
   

    li.slick-active button::before {
        color: rgb(150, 158, 171);
    }

    .slick-list {
        overflow: visible;
    }

    button {
        z-index: 1;
    }

`

const Wrap = styled.div`
    cursor: pointer;
    img {
        border: 4px solid transparent;
        border-radius: 4px;
        width: 100%;
        height: 100%;
        box-shadow: rgb(0 0 0 / 69%) 0px 26px 30px -10px,
        rgb(0 0 0 / 73%) 0px 16px 10px -10px;
        transition-duration: 300ms;

        &:hover {
            border: 4px solid rgb(249, 249, 249, 0.8);
        }
    }

`